import { isPreviewMode } from '../preview/preview'

type ErrorScreenProps = {
  message: string
}

const openPreview = () => {
  const params = new URLSearchParams(window.location.search)
  params.set('preview', '1')
  window.location.search = params.toString()
}

export const ErrorScreen = ({ message }: ErrorScreenProps) => (
  <main className="screen">
    <h1>Не удалось войти</h1>
    <p className="lead">{message}</p>
    <p className="muted">Попробуйте закрыть и открыть mini app из уведомления бота снова.</p>
    {!isPreviewMode() ? (
      <button type="button" className="echat-btn echat-btn--ghost" onClick={openPreview}>
        Посмотреть демо интерфейса
      </button>
    ) : null}
  </main>
)
